import { render, staticRenderFns } from "./SampleFormAnalytes.vue?vue&type=template&id=21993ffd"
import script from "./SampleFormAnalytes.vue?vue&type=script&lang=js"
export * from "./SampleFormAnalytes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports